import { Static, Object, String, Optional, Number, Array } from '@sinclair/typebox';

import { TravelPassRequestBound } from './confirm';
import { TravelPassApiError, TravelPassError } from './error';

export const TravelPassTaxSplitRequest = Object({
  offerId: String(),
  outbound: Optional(TravelPassRequestBound),
  inbound: Optional(TravelPassRequestBound),
  paxCount: Number(),
  productCode: String(),
});
export type TravelPassTaxSplitRequest = Static<typeof TravelPassTaxSplitRequest>;

export const TravelPassTaxSplitError = TravelPassApiError(TravelPassError);
export type TravelPassTaxSplitError = Static<typeof TravelPassTaxSplitError>;
export const TaxDetails = Object({
  label: String(),
  amount: Number(),
});
export type TaxDetails = Static<typeof TaxDetails>;

export const TravelPassTaxSplitResponse = Object({
  taxDetails: Array(TaxDetails),
});
export type TravelPassTaxSplitResponse = Static<typeof TravelPassTaxSplitResponse>;
